import React from 'react';

import { EVENT_TYPE } from 'src/features/eventLog/types';
import { StatisticEvent, StatisticEventData } from 'src/features/home/types';
import { cn } from 'src/utils/shadcn';

type EventHandler = (eventData: StatisticEventData, event: StatisticEvent) => string | null | React.ReactNode;

type CellEventIdentifierProps = {
    eventData: StatisticEventData;
    event: StatisticEvent;
    handleIdentifierClick?: (identifier: string, eventType?: EVENT_TYPE) => void;
};

const CellEventIdentifier = ({ eventData, event, handleIdentifierClick }: CellEventIdentifierProps) => {
    const renderLink = (
        linkName: string,
        onLinkClick?: (linkName: string, eventType?: EVENT_TYPE) => void,
    ): React.ReactNode =>
        onLinkClick ? (
            <button
                type="button"
                onClick={() => onLinkClick(linkName, event.event_type)}
                className={cn('text-primary-700 hover:text-primary-600 cursor-pointer font-semibold')}
            >
                {linkName}
            </button>
        ) : (
            linkName
        );

    const eventHandlers: Record<string, EventHandler> = {
        license_plate: (data) => {
            if ('license_plate' in data) {
                const licensePlate = data?.license_plate;
                return licensePlate ? renderLink(licensePlate, handleIdentifierClick) : '-';
            }
            return null;
        },

        identifiers: (data) => {
            if ('identifiers' in data) {
                const identifiersValue = data?.identifiers?.[0]?.value;
                return identifiersValue ? renderLink(identifiersValue, handleIdentifierClick) : '-';
            }
            return null;
        },

        value: (data) => {
            if ('value' in data) {
                const identifiersValue = data?.value;
                return identifiersValue ? renderLink(identifiersValue, handleIdentifierClick) : '-';
            }
            return null;
        },

        visitor: (data) => {
            if ('visitor' in data) {
                const visitor = Array.isArray(data.visitor)
                    ? data.visitor[0]?.main_identifier?.value
                    : data.visitor?.main_identifier?.value;
                return visitor ? renderLink(visitor, handleIdentifierClick) : '-';
            }
            return null;
        },
    };

    const getEventIdentifier = (eventData: StatisticEventData, event: StatisticEvent) => {
        for (const key in eventHandlers) {
            const message = eventHandlers[key](eventData, event);
            if (message) return message;
        }
        return '-';
    };

    return <div className="min-w-0">{getEventIdentifier(eventData, event)}</div>;
};

export default CellEventIdentifier;
